import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({}, km({

  PAY_GET_STATUS_SUCCESS: null,
  PAY_GET_STATUS_ERROR: null,
  PAY_GETTER_STATUS: null,

  
}))

  